/* https://www.kirupa.com/html5/get_element_position_using_javascript.htm */

export function GetCoords(elem, callback) {
  const res = { x: 0, y: 0 };
  const calc = (elem) => {
    if (elem) {
      let scrollLeft = elem.scrollLeft;
      let scrollTop = elem.scrollTop;
      // If this is the body, also respect scroll of documentElement.
      if (elem == document.body) {
        scrollLeft += document.documentElement.scrollLeft;
        scrollTop += document.documentElement.scrollTop;
      }
      res.x += elem.offsetLeft + elem.clientLeft - scrollLeft;
      res.y += elem.offsetTop + elem.clientTop - scrollTop;
      res.relativeTo = elem;
      if (!callback?.(elem)) calc(elem.offsetParent);
    }
  };
  calc(elem);
  return res;
}

export function GetFixedPositionCallback(elem, callback, context) {
  context = context || {};
  context.x = context.x || 0;
  context.y = context.y || 0;
  if (elem) {
    // Include elem in context for callback.
    context.elem = elem;
    context.nextElem = context.elem.offsetParent;
    if (context.elem.tagName === 'BODY') {
      // Deal with browser quirks with body/window/document and page scroll.
      let xScroll = context.elem.scrollLeft || document.documentElement.scrollLeft;
      let yScroll = context.elem.scrollTop || document.documentElement.scrollTop;

      context.x += context.elem.offsetLeft - xScroll + context.elem.clientLeft;
      context.y += context.elem.offsetTop - yScroll + context.elem.clientTop;
    } else {
      // For all other non-BODY elements.
      context.x += context.elem.offsetLeft - context.elem.scrollLeft + context.elem.clientLeft;
      context.y += context.elem.offsetTop - context.elem.scrollTop + context.elem.clientTop;
    }
    let proceed = () => GetFixedPositionCallback(context.nextElem, callback, context);
    if (typeof callback === 'function') callback(context, proceed);
    else proceed();
  } else {
    context.nextElem = window;
  }
  return context;
}

export function GetFixedPosition(elem, breakCondition) {
  let y = 0;
  let x = 0;
  while (elem) {
    if (breakCondition && breakCondition(elem)) break;
    if (elem.tagName === 'BODY') {
      // Deal with browser quirks with body/window/document and page scroll.
      let xScroll = elem.scrollLeft || document.documentElement.scrollLeft;
      let yScroll = elem.scrollTop || document.documentElement.scrollTop;

      x += elem.offsetLeft - xScroll + elem.clientLeft;
      y += elem.offsetTop - yScroll + elem.clientTop;
    } else {
      // For all other non-BODY elements.
      x += elem.offsetLeft - elem.scrollLeft + elem.clientLeft;
      y += elem.offsetTop - elem.scrollTop + elem.clientTop;
    }
    elem = elem.offsetParent;
  }
  elem = elem || window;
  return { y, x, elem };
}

// export function GetFixedPositionSVG(elem, breakCondition) {
//   let y = 0;
//   let x = 0;
//   while (elem && elem instanceof SVGElement) {
//     if (breakCondition && breakCondition(elem)) break;
//     x += Number(elem.getAttribute('x'));
//     y += Number(elem.getAttribute('y'));
//     elem = elem.parentElement;
//   }
//   elem = elem || window;
//   return {y, x, elem};
// };
